<accredible-confirm-dialog
  *transloco="let t; read: 'confirm-bulk-dialog'"
  [confirmDialogTitle]="t('title')"
  [confirmDialogText]="t('text')"
  actionBtnColor="primary"
  [cancelBtnText]="null"
  [actionBtnText]="t('ok')"
  confirmDialogImage="/assets/images/loading_v2.svg"
  (actionBtnClicked)="confirmBulk()" />
